const switchEnum = Object.freeze({
    ON : 5,
    OFF: 10,
});
export default switchEnum;
